<template>
  <div class="firstpage">
    <div class="main-contain">
      <div class="carousel">
        <Carousel></Carousel>
      </div>
      <div class="section-head">
        <div class="section-title">文化活动</div>
      </div>
      <div class="section activity">
        <Activity />
      </div>
      <div class="section news">
        <NewsReport />
      </div>
      <div class="section album">
        <ActivityPhotos />
      </div>
      <div class="section-head">
        <div class="section-title">文化直播</div>
      </div>
      <div class="section live">
        <Live :is-mobile="isMobile" />
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/views/index/components/carousel.vue" // 广告位
import Activity from "@/views/index/components/activity.vue" // 推荐活动
import NewsReport from "@/views/index/components/news.vue" // 新闻报道
import ActivityPhotos from "@/views/index/components/album.vue" // 活动图片
import Live from "@/views/index/components/live.vue" // 正在直播
export default {
  name: "Index",
  components: {
    Carousel,
    Activity,
    NewsReport,
    ActivityPhotos,
    Live,
  },
  data() {
    return {
      isMobile: false, // 判断手机端字段
    }
  },
  created() { },
  methods: {},
};
</script>
<style scoped lang="scss">
.firstpage {
  .main-contain {
    .carousel {
      background-color: #ccc;
      margin: 0 auto 30px;
    }

    .section {
      max-width: 1800px;
      margin: 0 auto 36px;
    }

    .section-head {
      width: 100%;
      height: 60px;
      line-height: 60px;
      background: url('~@/assets/home/title_bg.png') no-repeat;
      background-position: center bottom;
      margin: 0 auto 20px;

      .section-title {
        color: #000;
        // font-family: "楷体", "宋体",serif;
        font-size: 36px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .firstpage {
    .main-contain {
      .section {
        max-width: 640px;
        padding: 0 10px;
        box-sizing: border-box;
      }

      .section-head {
        height: 40px;
        line-height: 40px;
        background-size: auto 50%;

        .section-title {
          font-size: 24px;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .firstpage {
    .main-contain {
      .section {
        max-width: 1200px;
      }

      .section-head {
        .section-title {
          font-size: 30px;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .firstpage {
    .main-contain {
      .section {
        max-width: 1800px;
      }

      .section-head {
        .section-title {
          font-size: 36px;
        }
      }
    }
  }
}
</style>
